import Slider from './Slider';
import SliderExplenation from './SliderExplenation';
import Wordpicker from './Wordpicker';
import RelationOverview from './RelationOverview';
import Endscreen from './Endscreen';
import WordExplainer from './WordExplainer';
import DependWordpicker from './DependWordPicker';
import BoardPicker from './BoardPicker';
import NetworkPicker from './NetworkPicker';
import NetworkWordPicker from './NetworkWordPicker';
import NetworkOverview from './NetworkOverview';
import InverseWordpicker from './InverseWordpicker';

export default {
  Slider,
  SliderExplenation,
  Wordpicker,
  RelationOverview,
  Endscreen,
  WordExplainer,
  DependWordpicker,
  BoardPicker,
  NetworkPicker,
  NetworkWordPicker,
  NetworkOverview,
  InverseWordpicker,
};
